<template>
  <div class="course-ware" v-loading="loading">
    <el-button
      plain
      round
      size="small"
      type="primary"
      style="margin-bottom: 10px;"
      @click="wareFormOpen('add', { courseCode: courseCode })"
      v-if="isEdit && !hideToolbar"
      >新增课件</el-button
    >
    <el-table :data="wareList" style="width: 100%;" stripe>
      <el-table-column
        label="文件名称"
        prop="resourceName"
        align="center"
      ></el-table-column>
      <el-table-column label="类型" prop="resourceType" align="center">
        <template #default="scope">
          <dict-tag :type="DICT_TYPE.RESOURCE_TYPE" :value="scope.row.resourceType" />
        </template>
      </el-table-column>
      <el-table-column label="大小" prop="fileSize" align="center">
        <template #default="scope">
          {{ formatFileSize(scope.row.fileSize) }}
        </template>
      </el-table-column>
      <el-table-column
        label="上传时间"
        prop="createTime"
        align="center"
      ></el-table-column>
      <el-table-column label="操作" width="260" align="center">
        <template #default="scope">
          <el-button
            plain
            round
            size="small"
            type="primary"
            @click="warePreview(scope.row)"
            >预览</el-button
          >
          <el-button
            plain
            round
            size="small"
            type="primary"
            @click="wareDownload(scope.row)"
            v-if="showDownload"
            >下载</el-button
          >
          <el-button
            plain
            round
            size="small"
            type="success"
            @click="wareFormOpen('edit', scope.row)"
            v-if="isEdit"
            >编辑</el-button
          >
          <el-button
            plain
            round
            size="small"
            type="danger"
            @click="wareDelete(scope.row)"
            v-if="isEdit"
            >删除</el-button
          >
        </template>
      </el-table-column>
    </el-table>
    <div class="course-btn" v-if="isEdit">
      <el-button plain round size="small" @click="previous">上一步</el-button>
      <el-button plain round size="small" type="primary" @click="next"
        >完成</el-button
      >
    </div>
    <WareForm ref="wareFormRef" @success="handleWareSuccess" />
    <ResourcePreviewDialog ref="resourcePreviewRef" />
  </div>
</template>
<script>
import { getCourseDetail, updateCourse } from "@/api/course";
import { getIntDictOptions, DICT_TYPE } from "@/utils/dict";

import {
  parseCourseware,
  stringifyCourseware,
  formatDateTime,
  formatFileSize
} from "@/utils/util";
import WareForm from "./components/WareForm";
import ResourcePreviewDialog from "@/components/ResourcePreviewDialog";

export default {
  name: "CourseWare",
  components: {
    WareForm,
    ResourcePreviewDialog
  },
  props: {
    courseCode: [String, Number],
    /** 已加载的课程详情；传入后不再重复请求详情接口 */
    courseData: {
      type: Object,
      default: null
    },
    isEdit: { type: Boolean, default: true },
    showDownload: { type: Boolean, default: false },
    hideToolbar: { type: Boolean, default: false }
  },
  data() {
    return {
      DICT_TYPE,
      courseInfo: {},
      loading: false,
      wareList: []
    };
  },
  computed: {
    resourceTypeList() {
      return getIntDictOptions(DICT_TYPE.RESOURCE_TYPE);
    }
  },
  watch: {
    courseCode(val, oldVal) {
      if (val && val !== oldVal) {
        this.getWareList();
      }
    }
  },
  created() {
    this.getWareList();
  },
  methods: {
    formatFileSize,
    applyCourseData(data) {
      this.courseInfo = data || {};
      this.wareList = parseCourseware(this.courseInfo.courseware);
    },
    async getWareList() {
      if (this.courseData && Object.keys(this.courseData).length) {
        this.applyCourseData(this.courseData);
        return;
      }
      if (!this.courseCode) {
        return;
      }
      this.loading = true;
      try {
        const res = await getCourseDetail(this.courseCode);
        this.applyCourseData(res.data || {});
      } catch (e) {
      } finally {
        this.loading = false;
      }
    },
    async saveCourseware(list) {
      const courseware = stringifyCourseware(list);
      await updateCourse({
        ...this.courseInfo,
        courseware
      });
      this.courseInfo = { ...this.courseInfo, courseware };
      this.wareList = list;
    },
    async handleWareSuccess(payload) {
      const list = [...this.wareList];
      if (payload.type === "add") {
        list.push({
          ...payload.data,
          wareId: `ware_${Date.now()}`,
          createTime: formatDateTime(new Date())
        });
      } else {
        const index = list.findIndex(item => item.wareId === payload.wareId);
        if (index > -1) {
          list[index] = { ...list[index], ...payload.data };
        }
      }
      try {
        this.loading = true;
        await this.saveCourseware(list);
        this.$message.success(payload.type === "add" ? "新增成功" : "修改成功");
      } catch (e) {
      } finally {
        this.loading = false;
      }
    },
    wareFormOpen(type, row = {}) {
      this.$refs.wareFormRef.open(type, row, this.wareList);
    },
    warePreview(row) {
      const url = row.urls || row.url || row.resourceUrl;
      if (!url) {
        this.$message.warning("暂无文件地址");
        return;
      }
      this.$refs.resourcePreviewRef.open({
        url,
        name: row.fileName || row.resourceName || "资源预览",
        resourceType: row.resourceType,
        resourceTypeList: this.resourceTypeList
      });
    },
    async wareDownload(row) {
      const url = row.urls || row.url || row.resourceUrl;
      if (!url) {
        this.$message.warning("暂无文件地址");
        return;
      }
      const fileName = row.fileName || row.resourceName || "课件";
      try {
        this.loading = true;
        const res = await fetch(url, { mode: "cors" });
        if (!res.ok) {
          throw new Error("download failed");
        }
        const blob = await res.blob();
        const href = window.URL.createObjectURL(blob);
        const link = document.createElement("a");
        link.href = href;
        link.download = fileName;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        window.URL.revokeObjectURL(href);
      } catch (e) {
        this.$message.error("下载失败，请检查文件地址或跨域配置");
      } finally {
        this.loading = false;
      }
    },
    wareDelete(row) {
      this.$confirm("确定删除该课件吗？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then(async () => {
        const list = this.wareList.filter(item => item.wareId !== row.wareId);
        try {
          this.loading = true;
          await this.saveCourseware(list);
          this.$message.success("删除成功");
        } catch (e) {
        } finally {
          this.loading = false;
        }
      });
    },
    previous() {
      this.$emit("previous");
    },
    next() {
      this.$router.push("/course");
    },
    cancel() {
      this.$router.push("/course");
    }
  }
};
</script>
<style scoped lang="less">
.course-ware {
  .course-btn {
    display: flex;
    justify-content: center;
    margin-top: 20px;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/CourseEdit/CourseWare.vue